var styleDataHash = "146622c0";
const injectCss = () => {
  var css = `._19XgR{display:flex;position:relative}._19XgR:hover{color:var(--ricos-settings-text-color,#000)}.xukca{color:var(--ricos-settings-text-color,#333);font-size:16px;font-weight:300;height:40px;line-height:16px;width:100%}[dir] .xukca{border:1px solid var(--ricos-settings-inputs-border-color,rgba(0,0,0,.6));border-radius:var(--ricos-settings-inputs-border-radius,0)}[dir=ltr] .xukca{padding-left:37px}[dir=rtl] .xukca{padding-right:37px}.xukca::placeholder{color:var(--ricos-settings-inputs-placeholder-color,#646464)}[dir] .xukca:focus,[dir] .xukca:hover{border:1px solid rgba(var(--ricos-settings-action-color-tuple,0,0,0),.5)!important}.OjCof,.W26Gq{bottom:0;position:absolute;top:0;width:24px;fill:var(--ricos-settings-icons-color,#000);color:var(--ricos-settings-icons-color,#000)}[dir] .OjCof,[dir] .W26Gq{margin:auto}[dir=ltr] .OjCof{left:7px}[dir=rtl] .OjCof{right:7px}.W26Gq{height:16px;width:16px}[dir] .W26Gq{background-color:#f0f0f0;border-radius:50%;cursor:pointer}[dir=ltr] .W26Gq{right:11px}[dir=rtl] .W26Gq{left:11px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var text_search_input_default = {
  "container": "_19XgR",
  "input": "xukca",
  "prefixIcon": "OjCof",
  "suffixIcon": "W26Gq"
};
export {
  text_search_input_default as default,
  injectCss
};
//# sourceMappingURL=text-search-input-scss.js.map
